export enum ToasterStatus {
  SUCCESS,
  FAIL,
}
